import React, { PropsWithChildren } from 'react';
import { Row, Col } from 'reactstrap';
import './index.css';

export type ItemContainerHeaderProps = {};

const ItemContainerHeader = ({
  children,
}: PropsWithChildren<ItemContainerHeaderProps>) => (
  <Row noGutters className={`ic-header${children ? ' m-2' : ''}`}>
    <Col>{children}</Col>
  </Row>
);

export default ItemContainerHeader;
